import types from 'constants/AuthConstants';
import axios from 'axios';
import {push} from 'react-router-redux';
import qs from 'qs';
import {getURL} from '../routes';

export function changepasswordAPI(oldPwd, newPwd) {
	return axios.put(getURL("/api/auth"),
										qs.stringify({
										'old': oldPwd,
										'new': newPwd
									}))
}

export function logout() {
	return dispatch => {
		axios({
			method: 'delete',
			url: getURL("/api/auth"), 
			withCredentials: true,
			})
			.then(function(response) {				
				dispatch(removeAuthUser());
				dispatch(push(getURL('/login')));
			})
			.catch(function (error) {
			});
	}
}

export function login(claim, pw, remeber) {
	return dispatch => {
		dispatch(attempLogin());
		axios({
			method: 'post',
			url: getURL("/api/auth"), 
			data: qs.stringify({
				'claim': claim,
				'pwd': pw,
				'needRemeber': remeber,
			}),
			withCredentials: true,
			})
			.then(function(response) {
				let data = response.data;
        dispatch(fetchUserData(data.token));
			})
			.catch(function (error) {
				dispatch(loginFail())
			});
	}
}

export function whois() {
	return axios.get(getURL("/api/whois"))
}

export function checkUserRole(roleList, fn=undefined) {
	return dispatch => 
		whois()
			.then((response) => {
				let {name, role} = response.data;
				if (!roleList.includes(role)) {
					dispatch(setAuthUser(name, role));
					dispatch(push(getURL('/')));
				} else if (fn !== undefined) {
					dispatch(setAuthUser(name, role));
					fn();
				}
			})
			.catch((error) => {
			})
}

export function fetchUserData(token) {
	return dispatch => {
		axios.get(getURL("/api/whois?") +  
			qs.stringify({
				'sx': token,
			}))
			.then(function(response) {
				let data = response.data;

        dispatch(setAuthUser(data.name));
				dispatch(push(getURL('/')));
			})
			.catch(function (error) {
				dispatch(loginFail())
			});
	}
} 

export function fetchUserDataByCookies() {
	return dispatch => {
		whois()
			.then(function(response) {
				let {name, role} = response.data;
        dispatch(setAuthUser(name, role));
			})
			.catch(function (error) {
				dispatch(push(getURL('/login')));
			});
	}
}

export function attempLogin() {
	return {
		type: types.ATTEMP_LOGIN
	}
}

export function setAuthUser(userName, role) {
	return {
		type: types.SET_AUTH_INFO,
		userName, role
	}
}

export function loginFail() {
  return {
    type: types.AUTH_FAIL
  }
}

export function removeAuthUser() {
	return {
		type: types.REMOVE_AUTH_INFO,
	}
}


// WEBPACK FOOTER //
// ./src/actions/AuthActions.js